import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    IconButton,
    FormControlLabel,
    Switch,
    Typography,
    Alert,
    InputAdornment
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ConfigBackupModal = ({ show, onHide, config, onSave }) => {
    const [localConfig, setLocalConfig] = useState({
        enabled: false,
        intervalDays: 1,
        retentionDays: 30
    });
    const [error, setError] = useState('');

    useEffect(() => {
        if (config) {
            setLocalConfig(config);
        }
    }, [config]);

    const handleChange = (prop) => (event) => {
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setLocalConfig({ ...localConfig, [prop]: value });
    };

    const handleSave = () => {
        // Validation
        if (localConfig.enabled) {
            if (localConfig.intervalDays < 1) {
                setError('El intervalo debe ser al menos 1 día.');
                return;
            }
            if (localConfig.retentionDays < 1) {
                setError('La retención debe ser al menos 1 día.');
                return;
            }
        }
        setError('');
        onSave(localConfig);
    };

    return (
        <Dialog
            open={show}
            onClose={onHide}
            maxWidth="sm"
            fullWidth
            slotProps={{
                paper: {
                    style: {
                        borderRadius: '12px',
                        padding: '0.5rem'
                    }
                }
            }}
        >
            <DialogTitle style={{
                fontFamily: 'var(--font-family-base)',
                fontWeight: '600',
                fontSize: '1.5rem',
                color: '#1e293b',
                paddingRight: '3rem'
            }}>
                <i className="bi bi-gear-fill text-primary me-2"></i>
                Configuración de Backups
                <IconButton
                    aria-label="close"
                    onClick={onHide}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers style={{ padding: '1.5rem' }}>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                )}

                <div className="mb-4">
                    <FormControlLabel
                        control={
                            <Switch
                                checked={localConfig.enabled}
                                onChange={handleChange('enabled')}
                                color="primary"
                            />
                        }
                        label={
                            <Typography style={{ fontFamily: 'var(--font-family-base)', fontWeight: 500 }}>
                                Habilitar Backups Automáticos
                            </Typography>
                        }
                    />
                </div>

                <div className="row g-3">
                    <div className="col-12">
                        <TextField
                            label="Intervalo de Ejecución"
                            type="number"
                            fullWidth
                            disabled={!localConfig.enabled}
                            value={localConfig.intervalDays}
                            onChange={handleChange('intervalDays')}
                            variant="outlined"
                            InputProps={{
                                endAdornment: <InputAdornment position="end">Días</InputAdornment>,
                                style: { fontFamily: 'var(--font-family-base)', borderRadius: '8px' }
                            }}
                            helperText="Cada cuántos días se realizará el backup"
                        />
                    </div>
                    <div className="col-12">
                        <TextField
                            label="Retención de Backups"
                            type="number"
                            fullWidth
                            value={localConfig.retentionDays}
                            onChange={handleChange('retentionDays')}
                            variant="outlined"
                            InputProps={{
                                endAdornment: <InputAdornment position="end">Días</InputAdornment>,
                                style: { fontFamily: 'var(--font-family-base)', borderRadius: '8px' }
                            }}
                            helperText="Los backups más antiguos que este número de días serán eliminados automáticamente"
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions style={{ padding: '1rem 1.5rem' }}>
                <Button
                    onClick={onHide}
                    style={{
                        fontFamily: 'var(--font-family-base)',
                        fontWeight: '600',
                        color: '#64748b'
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    style={{
                        fontFamily: 'var(--font-family-base)',
                        fontWeight: '600',
                        background: '#3B82F6',
                        borderRadius: '8px'
                    }}
                >
                    Guardar Cambios
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfigBackupModal;

